import { render, staticRenderFns } from "./ColorTestButtons.vue?vue&type=template&id=1c36b61a&scoped=true"
import script from "./ColorTestButtons.vue?vue&type=script&lang=js"
export * from "./ColorTestButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c36b61a",
  null
  
)

export default component.exports